import { createContext } from 'react'
import { ConfigParams } from './types'

export const ConfigParamsContext = createContext<ConfigParams>({})
